import get from 'lodash/get';
import * as giftGuide from '../../action_creators/gift_guide/gift_guide_action_creators';
import GiftGuideModel from '../../../models/gift_guide/gift_guide_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchGiftGuideDetail(params, store) {
  return function firstDispatch(dispatch) {
    const idMapping = {
      'holiday-2017': 1
    };
    const requestParams = {
      id: idMapping[get(params, 'slug', 0)]
    };

    if (params.category) {
      requestParams.category = params.category;
    }

    return GiftGuideModel.fetch(requestParams, store)
      .then(function handleGiftGuideDetailData(GiftGuideData) {
        if (requestParams.category) {
          const hasGiftGuideGuideCategory = GiftGuideData.data.rows.filter(
            category => category.url === requestParams.category
          );

          if (!get(hasGiftGuideGuideCategory, 'length')) {
            dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          }
        }

        dispatch(
          giftGuide.giftGuideLoaded(GiftGuideData.data, store, requestParams.id)
        );
      })
      .catch(function handleUserError(err) {
        if (err.message === 'Invalid Year') {
          log.warn('User tried a most creative people page with invalid year.');
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          return dispatch(giftGuide.giftGuideLoadError(err, store));
        }

        const status = get(err, 'response.status');

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in giftGuide actions, message: ${err.message}`);
        }
        return dispatch(giftGuide.giftGuideLoadError(err, store));
      });
  };
}
